import React from 'react';
import { useStore } from '@cobuildlab/react-simple-state';
import { userChangeStatusDialogStore } from '../user-stores';
import { MuiDialog } from '../../../shared/components/dialog/MuiDialog';
import { UsersDocument, UserStatus, useUpdateUserMutation } from '../../../shared/types/generated';
import { userChangeStatusDialogStoreAction } from '../user-actions';

type UserChangeStatusDialogProps = {
  onSuccess?: () => void;
}

export const UserChangeStatusDialog: React.FC<UserChangeStatusDialogProps> = ({ onSuccess }) => {
  const { user, open } = useStore(userChangeStatusDialogStore);
  const handleClose = (): void => {
    userChangeStatusDialogStoreAction({ open: false, user: undefined });
  };
  const [update, { loading }] = useUpdateUserMutation({
    awaitRefetchQueries: true,
    refetchQueries: [UsersDocument],
    onCompleted: () => {
      handleClose();
      if (onSuccess) onSuccess();
    },
  });

  return (
    <MuiDialog
      open={Boolean(open)}
      handleClose={() => handleClose()}
      loading={loading}
      title='Change Status'
      maxWidth='sm'
      fullWidth
      handleSuccess={() => {
        update({
          variables: {
            data: {
              status: user?.status === UserStatus.Active ? UserStatus.Inactive : UserStatus.Active,
            },
            where: {
              id: user?.id,
            },
          },
        });
      }}
      renderActions
    >
      Do you want to change status?
    </MuiDialog>
  );
};